







































import {
	defineComponent,
	nextTick,
	PropType,
	reactive,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';

export default defineComponent({
	props: {
		buttons: {
			type: Array as PropType<ButtonNavButton[]>,
			required: true,
		},
		selectedKey: {
			type: String as PropType<string | null>,
			default: null,
		},
		withPinLine: Boolean,
	},
	setup(props) {
		const rootEl = ref(null) as Ref<null | HTMLSpanElement>;
		const indicator = ref(null) as Ref<null | HTMLSpanElement>;
		const indicatorStyle = reactive({
			left: '0px',
			right: '0px',
		});
		watch([() => props.selectedKey, rootEl, indicator], async () => {
			await nextTick();
			if (!rootEl.value || !indicator.value) {
				return;
			}
			const activeElement = rootEl.value.querySelector('.tabbed-nav__button--active') as HTMLElement | null;
			if (!activeElement) {
				return;
			}
			const rootWidth = rootEl.value.offsetWidth;
			indicatorStyle.left = `${activeElement.offsetLeft}px`;
			indicatorStyle.right = `${rootWidth - activeElement.offsetLeft - activeElement.offsetWidth}px`;
		});
		return {
			rootEl,
			indicator,
			indicatorStyle,
		};
	},
});
